import React, { Component } from 'react';
import 'components/tenant_app/components/tenant_profile/TenantProfile.css';

import { reduxForm, FieldArray } from 'redux-form';
import { connect } from 'react-redux';

import validate from './validate';

import FlatButton from 'material-ui/FlatButton';

import { AccentColor } from 'helpers/AccentColorHelper';

import EmergencyContactsFieldArray from 'components/shared/EmergencyContactsFieldArray';

import scrollIntoView from 'scroll-into-view';
import { CSSTransitionGroup } from 'react-transition-group';
import { getTranslatedString } from 'helpers/i18n';

class RenderEmergencyContacts extends Component {
  UNSAFE_componentWillMount() {
    const { fields } = this.props;
    if (!fields.length) fields.push();
  }

  render() {
    return <EmergencyContactsFieldArray {...this.props} startDeletingAtIndex={1} />;
  }
}

class EmergencyContactsPage extends Component {
  render() {
    const { handleSubmit, previousPage } = this.props;

    const style = {
      button: {
        color: 'white',
        float: 'right',
        height: '40px',
      },
      backButton: {
        float: 'left',
        color: AccentColor(),
        height: '40px',
      },
    };

    return (
      <form onSubmit={handleSubmit}>
        <div id="top" style={{ marginTop: '50px' }}>
          <h3
            style={{
              fontSize: '30px',
              marginBottom: '20px',
              fontFamily: 'Circular-Bold',
            }}
          >
            {getTranslatedString('tenantPortal.tenantApplication.emergencyContacts.header')}{' '}
            <i className="em em-ambulance" />
          </h3>
          <CSSTransitionGroup
            transitionName="previousOccupation"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}
          >
            <FieldArray name="emergency_contacts" component={RenderEmergencyContacts} />
          </CSSTransitionGroup>
        </div>
        <div id="button" style={{ marginBottom: '75px' }} />
        <div id="application_footerbar">
          <div style={{ textAlign: 'center', maxWidth: '600px', margin: 'auto' }}>
            <FlatButton
              label={getTranslatedString('tenantPortal.tenantApplication.emergencyContacts.back')}
              type="button"
              className="previous"
              onClick={previousPage}
              backgroundColor="#fff"
              hoverColor="grey"
              style={style.backButton}
            />
            <FlatButton
              label={getTranslatedString('tenantPortal.tenantApplication.emergencyContacts.next')}
              type="submit"
              className="next"
              primary
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={style.button}
            />
          </div>
        </div>
      </form>
    );
  }
}

EmergencyContactsPage = reduxForm({
  form: 'wizard',
  destroyOnUnmount: false,
  validate,
  onSubmitFail: (errors) => {
    scrollIntoView(document.getElementById('errorMessage'), {
      time: 500,
      align: {
        top: 0.25,
      },
    });
  },
})(EmergencyContactsPage);

EmergencyContactsPage = connect((state) => ({
  initialValues: state.tenantApplication.tenantApplication,
}))(EmergencyContactsPage);

export default EmergencyContactsPage;
